const PROCEDURE_LOCK_PREFIX = 'procedure_lock';

/**
 * Set a cookie
 * @param name            string containing the cookie name
 * @param value           string containing the cookie value
 * @param expireMillis    number containing the expiration time
 * @param domain          {string | null} to specify the cookie domain
 */
export function setCookie(name: string, value: string, expireMillis: number, domain: string | null = '') {
  const expireDate = new Date();
  expireDate.setTime(expireMillis);
  const expires = `; expires=${expireDate.toUTCString()}`;
  const domainString = domain ? `domain=${domain};` : '';
  document.cookie = `${name}=${value || ''}${expires}; ${domainString} path=/`;
}

export function getCookie(name: string) {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function eraseCookie(name: string) {
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

/**
 * Removes all cookies that start with the PROCEDURE_LOCK_PREFIX.
 * This is used when releasing locks for a visit to ensure that any stale lock cookies are cleared.
 * At this point we are clearing all locks across all studies
 */
export function removeAllProcedureLockCookies(): void {
  const existingCookies = document.cookie.split(';');
  existingCookies.forEach((cookieStr: string) => {
    const trimmedCookie = cookieStr.trim();
    if (trimmedCookie.startsWith(PROCEDURE_LOCK_PREFIX)) {
      const cookieName = trimmedCookie.split('=')[0];
      eraseCookie(cookieName);
    }
  });
}
